<template>
    <v-dialog v-model="isOpen" max-width="800px" fullscreen persistent>
        <v-card>
            <v-toolbar dark color="orange">
                <v-btn icon dark @click="() => { handleCloseDeslinde(index) }">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>
                    Términos y Condiciones
                </v-toolbar-title>
            </v-toolbar>
            <div id="deslinde-online-container" class="pa-2 ">
                <h2 class="text-xs-center pa-2 title center">Deslinde de responsabilidad
                </h2>

                <div id="deslinde-online-viewer" class="ma-1 deslinde-online-viewer ">
                    <div>
                        <span v-html="textoDeslinde"> </span>
                    </div>
                </div>
                <div class="pa-2">

                    <h2 class=" text-xs-center ">Firme aquí</h2>

                    <div :ref="'signatureCanvas_' + index" class="signature-container"></div>

                    <div id="signature-preview" v-if="signatureData">
                        <img :src="signatureData" alt="Firma Digital" />
                    </div>

                    <div class="signature-buttons"
                        style="display: flex; justify-content: space-between; align-items: center;">
                        <span>Firma</span>
                        <v-btn ml-2 icon outline @click="() => clearSignature(index)">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </div>


                </div>
                <div class="signature-buttons pa-2" style="text-align: center;">
                    <div>{{ datosPersona.nombre }} {{ datosPersona.apellido }}</div>
                    <div>....................................................</div>
                    <div>Nombre y Apellido</div>
                </div>
            </div>

             <v-btn color="orange" @click="() => { handleAcceptDeslinde(index) }">Acepto el Deslinde</v-btn>

        </v-card>
    </v-dialog>
</template>
<script>
 
import SignaturePad from 'signature_pad';
import html2pdf from "html2pdf.js"; // Solo si lo instalaste con npm

export default {
    props: {
        isOpen: {
            type: Boolean,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        textoDeslinde: {
            type: String,
            required: true
        },
        datosPersona: {
            type: Object,
            required: true
        },

    },
    data() {
        return {
            signaturePad: null,
            signatureData: null
        }
    },
    watch: {
        isOpen: function (val) {
            if (val) {
                this.$nextTick(() => {
                    if (this.signaturePad) {
                        return;
                    }

                    const container = this.$refs['signatureCanvas_' + this.index];
                    if (!container) {
                        console.error("El contenedor de la firma no está disponible.");
                        return;
                    }

                    const canvas = document.createElement("canvas");
                    container.appendChild(canvas);

                    canvas.width = container.offsetWidth;
                    canvas.height = 200;

                    // Inicializar Signature Pad
                    this.signaturePad = new SignaturePad(canvas, {
                        backgroundColor: "#fff", // Fondo blanco
                        penColor: "black", // Color del lápiz
                        minWidth: 1, // Grosor mínimo del trazo
                        maxWidth: 3, // Grosor máximo del trazo                
                    });
                });
            }
        }
    },
   
    methods: {

        generateSignatureFromCanvas() {
            if (this.signaturePad && !this.signaturePad.isEmpty()) {
                this.signatureData = this.signaturePad.toDataURL("image/png");
            }
            return null;
        },

        downloadDeslindeAsPDF() {
            const element = document.getElementById("deslinde-online-container");
            element.classList.add("print");
            // Configuración opcional
            const options = {
                margin: 10,
                filename: "deslinde.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            };

            this.generateSignatureFromCanvas();

            html2pdf().set(options).from(element).save().then(() => {
                element.classList.remove("print");
            });

        },

        clearSignature(index) {
            this.signaturePad.clear();
        },

        handleAcceptDeslinde(index) {
            if (this.signaturePad && !this.signaturePad.isEmpty()) {
                const signatureData = this.signaturePad.toDataURL("image/png");
                console.log("Firma guardada:", signatureData);
                this.$emit('accept', { index, signature: signatureData });
            } else {
                alert("Por favor, dibuja una firma antes de guardar.");
                return;
            }
        },
        handleCloseDeslinde(index) {
            this.$emit('close', index);
        }
    }
}

</script>
<style>
.deslinde-online-viewer {
    max-height: 600px;
    overflow-y: auto;
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.print .deslinde-online-viewer {
    max-height: fit-content !important;
}

.signature-container {
    width: 80%;
    /* Asegura que el contenedor ocupe el ancho disponible */
    height: 200px;
    /* Altura definida */
    border: 2px solid #ccc;
    background: #f9f9f9;
    margin: 0 auto;
    position: relative;
    /* Necesario para evitar problemas de layout */
    border-radius: 10px;
}

.signature-container>canvas {
    width: 100%;
    height: 100%;
    border-radius: 10px;
}

.print .signature-container>canvas {
    display: none;
}

#signature-preview {
    width: 80%;
    height: 200px;
    margin: 0 auto;
    border: 2px solid #ccc;
    background: #f9f9f9;
    border-radius: 10px;
    display: none;
}

.print #signature-preview {
    display: block;
}


.print .signature-container {
    display: none;
}


.signature-buttons {
    width: 80%;
    margin: 0 auto;
}
</style>